// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Item_attributes_SalvarOpcaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/item_attributes/salvar_opcao
 *
 * Creates or updates an attribute option.
 * - Create: requires attribute_id, value, and display_order (option_id is null)
 * - Update: requires option_id, value, and display_order
 */
import { registerContract } from './validate'

export interface Item_attributes_SalvarOpcaoInput {
so_item_attribute_option_value: string
so_item_attribute_option_display_order: number
so_item_attribute_option_id?: number
so_item_attribute_option_attribute_id?: number
so_item_attribute_option_icon_svg?: string
}

registerContract('Item_attributes_SalvarOpcaoInput', {
  so_item_attribute_option_value:         { type: 'string',  required: true },
  so_item_attribute_option_display_order: { type: 'number',  required: true },
  so_item_attribute_option_id:            { type: 'number',  required: false },
  so_item_attribute_option_attribute_id:  { type: 'number',  required: false },
  so_item_attribute_option_icon_svg:      { type: 'string',  required: false },
})
